import {Injectable} from '@angular/core';
import {ContentCellId} from '@webmate-web-core/shared/types/testmgmt';
import {FindingId} from '@webmate-web-core/shared/types/ids';

export interface PendingFindingCellInsert {
    insertAtIndex: number;
    originalSequence: ContentCellId[];
}

@Injectable({
    providedIn: 'root'
})
export class FindingCellInsertService {
    private pendingInserts = new Map<FindingId, PendingFindingCellInsert>();

    registerPendingInsert(findingId: FindingId, insertAtIndex: number, originalSequence: ContentCellId[]): void {
        this.pendingInserts.set(findingId, {
            insertAtIndex,
            originalSequence: [...originalSequence]
        });
    }

    consumePendingInsert(findingId: FindingId): PendingFindingCellInsert | undefined {
        const pendingInsert = this.pendingInserts.get(findingId);
        this.pendingInserts.delete(findingId);
        return pendingInsert;
    }

    clearPendingInsert(findingId: FindingId): void {
        this.pendingInserts.delete(findingId);
    }

    clearPendingInsertsExcept(findingId?: FindingId): void {
        for (const pendingFindingId of this.pendingInserts.keys()) {
            if (!findingId || pendingFindingId !== findingId) {
                this.pendingInserts.delete(pendingFindingId);
            }
        }
    }

    shouldMoveCells(pendingInsert?: PendingFindingCellInsert): pendingInsert is PendingFindingCellInsert {
        return !!pendingInsert && pendingInsert.insertAtIndex < pendingInsert.originalSequence.length;
    }
}
